import React from "react";
import NotesIcon from "@mui/icons-material/Notes";
import { Container, RightContainer, Title } from "./styled";
import { useSelector } from "react-redux";
import moment from "moment";

const DataPreEntregaResult = () => {
  const thisCard = useSelector((state) => state.card);

  const formattedDate =
    thisCard.datePreEntrega && moment.utc(thisCard.datePreEntrega).isValid()
      ? moment.utc(thisCard.datePreEntrega).format("DD/MM/YYYY")
      : "-";

  return (
    <Container>
      <NotesIcon fontSize="small" />
      <RightContainer>
        <Title>Data Pré Entrega</Title>
        <p>{formattedDate}</p>
      </RightContainer>
    </Container>
  );
};

export default DataPreEntregaResult;
